<template>
  <div>
    <input type="hidden" :name="fieldName" v-model="fieldValue" aria-required>
    <div class="opts l_plans" :class="optClass" :id="fieldName" role="radiogroup" aria-required :aria-labelledby="`${fieldName}Title`">
      <template v-for="(opt, index) in builder[props.optionsSource]"
        :key="`${fieldName}${opt.id}`">
        
        <button
        type="button"
        :id="`${fieldName}${opt.id}`"
        class="opt"
        :class="[{
          's_active' : isSelected(builder[props.optionsSource][index]),
          's_hidden' : (builder.env == 'production' && !builder.testMode && props.optionsSource == 'productOptions' && !builder[props.optionsSource][index].active) || (props.optionsSource == 'productOptions' && builder[props.optionsSource][index].archived),
        }, optClass]"
        :disabled="builder.env == 'production' && !builder.testMode && props.optionsSource == 'productOptions' && builder[props.optionsSource][index].preview"
        @click="toggleSelect($event, index)"
        role="radio"
        :aria-checked="isSelected(builder[props.optionsSource][index])">
          <div class="opt-inner">
            <div class="opt-header">
              <div class="opt-title" v-if="!(props.displayType.includes('visual') && builder[props.optionsSource][index].id == 2643)" v-html="opt.title"></div>
              <div class="opt-subtitle" v-if="!props.displayType.includes('visual') && typeof opt.subtitle !== 'undefined'">
                {{ opt.subtitle }}
                <button class="opt-help" v-if="props.displayType.includes('delivery') && opt.description.length" @click.stop="lightboxActivate($event, index)">
                  ?
                </button>
              </div>
              <div class="opt-subtitle" v-else-if="builder.env == 'production' && !builder.testMode && props.optionsSource == 'productOptions' && builder[props.optionsSource][index].preview">Coming Soon</div>
              <button class="opt-help" v-if="(props.displayType.includes('combo') || props.displayType.includes('visual')) && (opt.description || opt.gallery)" @click.stop="lightboxActivate($event, index)">
                <svg class="icon"><use xlink:href="#zoom"></use></svg>
              </button>
            </div>
            <div class="opt-plan" v-if="props.optionsSource == 'productOptions' && opt.handle == 'sliding-wardrobe'">
              <Plan
                :layout="opt.handle"
                :sections="1"
                custom-class="sliding plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'productOptions' && opt.handle == 'walk-in-wardrobe'">
              <Plan
                :layout="opt.handle"
                :sections="3"
                custom-class="u-shape plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'productOptions' && opt.handle == 'sliding-wardrobe2'">
              <Plan
                :layout="opt.handle"
                :sections="1"
                custom-class="sliding plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'productOptions' && opt.handle == 'hinged-wardrobe'">
              <Plan
                :layout="opt.handle"
                :sections="1"
                custom-class="hinged plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'kitchenLayoutOptions'">
              <Plan
                :layout="opt.slug"
                :sections="opt.sections.length"
                custom-class="kitchen plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'laundryLayoutOptions'">
              <Plan
                :layout="opt.slug"
                :sections="opt.sections.length"
                custom-class="laundry plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'walkInWardrobeLayoutOptions'">
              <Plan
                :layout="opt.slug"
                :sections="opt.sections.length"
                custom-class="walk-in-wardrobe plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'slidingWardrobe2LayoutOptions'">
              <Plan
                :layout="opt.slug"
                :sections="opt.sections.length"
                custom-class="sliding plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan" v-else-if="props.optionsSource == 'hingedWardrobeLayoutOptions'">
              <Plan
                :layout="opt.slug"
                :sections="opt.sections.length"
                custom-class="hinged plan--min-walls"
              ></Plan>
            </div>
            <div class="opt-plan l_wallspace" v-else="props.optionsSource == 'wallSpaceOptions'">
              <Plan
                :wallspace="opt.slug"
              ></Plan>
            </div>
            <div class="opt-image" v-if="(props.displayType.includes('visual')) && opt.image"><div class="opt-img" :style="`background-image: url(${opt.image});`"></div></div>
          </div>
        </button>
        
        <div v-if="fieldName == 'deliveryType' && index == 0" class="optsep">OR</div>
      
      </template>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps([
  'key',
  'fieldName',
  'displayType',
  'optionsSource',
  'selected',
  'scope'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

const emit = defineEmits(['selectOption'])
const fieldValue = ref(props.selected);

// if (builder.range.handle == 'wardrobes' && !builder.testMode) emit('selectOption', props.fieldName, builder[props.optionsSource][0]);

function toggleSelect(e, optIndex) {
  emit('selectOption', props.fieldName, builder[props.optionsSource][optIndex]);
  e.preventDefault();
  return false;
}

function lightboxActivate(e, optIndex) {
  let description = builder[props.optionsSource][optIndex].description;
  let gallery = JSON.parse(builder[props.optionsSource][optIndex].gallery);
  lightbox.open(description, gallery);
  e.preventDefault();
  return false;
}

function isSelected(opt) {
  let compare = null;
  if (!_.isUndefined(props.scope) && props.scope.length) {
    if (props.scope == 'quote') compare = builder.quote[props.fieldName];
    else if (props.scope == 'section') compare = builder.currentSection[props.fieldName];
    else compare = builder.currentItem[props.scope][props.fieldName];
  } else {
    compare = builder.currentItem[props.fieldName];
  }
  if (opt['id'] == compare) return true;
  return false;
}
    
const optClass = computed(() => {
  let optClass = '';
  if (!_.isUndefined(props.displayType)) {
    let sep = '';
    for (let i = 0; i < props.displayType.length; i++) {
      optClass += sep + 'l_' + props.displayType[i];
      sep = ' ';
    }
  }
  return optClass;
})
</script>